import * as tslib_1 from "tslib";
function createMemoryCacheClient() {
    var _this = this;
    var cache = new Map();
    var timeouts = new WeakMap();
    var inflight = new Map();
    var set = function (key, execute, ttl) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var rejectInflight, resolveInflight, data, entry_1, err_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (cache.has(key)) {
                        return [2 /*return*/, Promise.resolve(cache.get(key).value)];
                    }
                    if (inflight.has(key)) {
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                inflight.get(key).push({ resolve: resolve, reject: reject });
                            })];
                    }
                    inflight.set(key, []);
                    rejectInflight = function (err) {
                        inflight.get(key).forEach(function (_a) {
                            var reject = _a.reject;
                            return reject(err);
                        });
                        inflight.delete(key);
                    };
                    resolveInflight = function () {
                        inflight.get(key).forEach(function (_a) {
                            var resolve = _a.resolve;
                            return resolve(cache.get(key).value);
                        });
                        inflight.delete(key);
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, execute()];
                case 2:
                    data = _a.sent();
                    entry_1 = { value: Object.freeze(data) };
                    cache.set(key, entry_1);
                    if (ttl && !timeouts.has(entry_1)) {
                        timeouts.set(entry_1, setTimeout(function () {
                            if (cache.has(key)) {
                                cache.delete(key);
                            }
                            timeouts.delete(entry_1);
                        }, ttl));
                    }
                    resolveInflight();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    rejectInflight(err_1);
                    throw err_1;
                case 4: return [2 /*return*/, data];
            }
        });
    }); };
    var reset = function (keys) {
        if (keys && keys.length) {
            keys.forEach(function (key) {
                cache.delete(key);
            });
        }
        else {
            cache.clear();
        }
    };
    return {
        set: set,
        reset: reset
    };
}
var memoryCacheClient = createMemoryCacheClient();
export { memoryCacheClient, createMemoryCacheClient };
//# sourceMappingURL=memory-cache-client.js.map